import { UseMutationResult } from '@tanstack/react-query'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import usePortalMutation from 'src/Libs/api/hooks/use-portal-mutation'
import { saveInstallationAddress } from '../api/installation-address.api'
import { InstallationAddressFormValues } from '../types'

interface SaveInstallationAddressVariables {
  installationId: number
  payload: InstallationAddressFormValues
}

interface UseSaveInstallationAddressParams {
  onSuccess?: () => void
  onError?: (error: Error) => void
}

/**
 * hook to save installation address and coordinates for installation which has missing coordinates.
 */
export const useSaveInstallationAddress = ({ onSuccess, onError }: UseSaveInstallationAddressParams = {}): UseMutationResult<
  null,
  Error,
  SaveInstallationAddressVariables
> => {
  const authFetch = useAuthFetchWithResponse()

  return usePortalMutation<null, Error, SaveInstallationAddressVariables>({
    mutationFn: ({ installationId, payload }) => saveInstallationAddress(installationId, payload, authFetch),
    onSuccess: () => onSuccess?.(),
    onError: error => onError?.(error),
  })
}
